import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { StyledRadioGroup } from "../../../DriverPopUp/common/RadioGroup";
import { VOID_REASON_LIST } from "../../../constants";
import FormSectionHeader from "../common/FormSectionHeader";
import { getFieldError } from "./utils";
import { TextFieldWithLabel } from "../components/TextField";
import { MAX_LENGTH_CONSTRAINTS } from "../constants";

const styles = (theme) => ({
  container: {
    display: "flex",
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: "4px",
    flexWrap: "wrap",
    justifyContent: "space-between",
    padding: 8,
  },
  commentsWrapper: {
    flexGrow: 1,
  },
  radioGroup: {
    marginRight: 48,
  },
  commentsLabel: {
    minWidth: 90,
    alignSelf: "flex-start",
    marginTop: 24,
  },
});

const VoidPickupForm = ({ classes, voidPickupData, updateVoidPickup }) => {
  const handleRadioChange = (value) => {
    updateVoidPickup({
      ...voidPickupData,
      voidReason: value,
      errorInfo: {
        ...voidPickupData.errorInfo,
        comment: null,
      },
      commentCount: voidPickupData.comment?.length ?? 0,
      error: null,
    });
  };

  const handleChange = (value) => {
    updateVoidPickup({
      ...voidPickupData,
      comment: value,
      errorInfo: {
        ...voidPickupData.errorInfo,
        comment: getFieldError("comment", value),
      },
      commentCount: value.length,
    });
  };

  const MAX_COMMENT_LENGTH = MAX_LENGTH_CONSTRAINTS.VOID_PICKUP_FORM.COMMENT;
  return (
    <>
      <FormSectionHeader label="Void Reason Info" />
      <div className={classes.container} id="voidPickup">
        <div className={classes.radioGroup}>
          <StyledRadioGroup
            onChange={handleRadioChange}
            options={VOID_REASON_LIST}
            value={voidPickupData.voidReason}
          />
        </div>
        <div className={classes.commentsWrapper}>
          <TextFieldWithLabel
            label="Comments :"
            id="comment"
            labelClass={classes.commentsLabel}
            handleChange={handleChange}
            error={voidPickupData.errorInfo.comment}
            inputClass={classes.comments}
            multiline
            rows={3}
            inputProps={{
              maxLength: MAX_COMMENT_LENGTH,
            }}
            helperText={`${
              voidPickupData.commentCount ?? 0
            }/${MAX_COMMENT_LENGTH}`}
          />
        </div>
      </div>
    </>
  );
};

export default withStyles(styles)(VoidPickupForm);
